import styled from 'styled-components'
import { MenuItem } from '@material-ui/core'
import { BLUE, RED } from 'constants/colors'

export const StyledClearSelectMenuItem = styled(MenuItem)`
  padding: 0;

  &:hover {
    background: transparent;
  }
`

export const StyledClearSelectButton = styled.div`
  width: 100%;
  cursor: pointer;
  padding: 6px 16px;
  color: ${BLUE};
`

export const ErrorValidationMessage = styled.div`
  color: ${RED};
  font-size: 14px;
  line-height: 140%;
  margin-top: 6px;
`
